import { combineReducers } from 'redux'
import config from './config'
import events from './events'

export default combineReducers({
  config,
  events,
})
